import { homeFrontService } from '../network/services/home-front.service';
import {ResponseError} from "../network/response/response-error";

export default {
  namespaced: true,
  state: {
    duration: 5000,
    loading: true,
    pictures: [],
    texts: [],
  },
  mutations: {
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
    SET_PICTURES(state, payload) {
      state.pictures = payload;
    },
    SET_TEXTS(state, payload) {
      state.texts = payload;
    },
  },
  actions: {
    async fetch(context, { lang }) {
      context.commit('SET_LOADING', true);
      const response = await homeFrontService.fetchBusinessSlider(lang);
      const roomPictures = response.get('RoomPicture.many', []);
      const businessSliderTexts = response.get('BusinessSliderText.many', []);
      if (!(roomPictures instanceof ResponseError)) {
        context.commit('SET_PICTURES', roomPictures);
      } else {
        //TODO catch errors
      }
      if (!(businessSliderTexts instanceof ResponseError)) {
        context.commit('SET_TEXTS', businessSliderTexts);
      } else {
        //TODO catch errors
      }
      context.commit('SET_LOADING', false);
    },
  },
};



// WEBPACK FOOTER //
// ./src/stores/business-slider.js